import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "tabStatus status-tabs order-tabs"
  }, [_vm._v(" " + _vm._s(_vm.t('状态：')) + " "), _c('a-tabs', {
    attrs: {
      "size": "small",
      "data-permission": "clearance_search_status",
      "id": "clearance_search_status",
      "animated": false
    },
    on: {
      "change": _vm.handleChangeStatus
    },
    model: {
      value: _vm.searchData.status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "status", $$v);
      },
      expression: "searchData.status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text + "(" + item.total + ")"
      }
    });
  }), 1)], 1), _c('a-form', {
    staticClass: "ant-advanced-search-form",
    attrs: {
      "layout": "inline",
      "from": _vm.searchData
    }
  }, [_c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, _vm._l(_vm.codeTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "maxLength": 100,
      "data-permission": "clearance_search_handle_db_Click",
      "id": "clearance_search_handle_db_Click",
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleSearch($event);
      }
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u76EE\u7684\u4ED3\uFF08\u533A\u57DF\uFF09"),
      "allowClear": "",
      "show-tip": "",
      "show-search": "",
      "data-permission": "clearance_search_objective",
      "id": "clearance_search_objective",
      "placeholder": _vm.t('目的仓（区域）')
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u4E2D\u8F6C\u4ED3"),
      "allowClear": "",
      "show-tip": "",
      "show-search": "",
      "data-permission": "clearance_search_transit",
      "id": "clearance_search_transit",
      "placeholder": _vm.t('中转仓')
    },
    model: {
      value: _vm.searchData.transit_warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "transit_warehouse_code", $$v);
      },
      expression: "searchData.transit_warehouse_code"
    }
  }, _vm._l(_vm.transitionWarehouseList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.transit_warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.transit_warehouse_code) + "[" + _vm._s(item.transit_warehouse_name) + "] ")]);
  }), 1)], 1)], 1), _c('a-form-item', [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.timeTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(_vm.tc(item.text)))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1)], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "data-sign": "clearance_search",
      "data-permission": "clearance_search_btn",
      "id": "clearance_search_btn",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "clearance_search_reset",
      "id": "clearance_search_reset",
      "data-sign": "clearance_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "listTool mt-10"
  }, [_c('div', {
    staticClass: "fl"
  }, [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(_vm.selectedList.length) + " "), _c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-sign": "clearance_export_all",
      "data-permission": "clearance_export_all",
      "id": "clearance_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-sign": "clearance_export_selected",
      "data-permission": "clearance_export_select",
      "id": "clearance_export_select",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _vm.$enum.clearance.ClearanceStatusEnum.UNCONFIRM === _vm.searchData.status ? [_c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'clearance_confirm_bulk',
      expression: "'clearance_confirm_bulk'"
    }],
    attrs: {
      "data-permission": "clearance_confirm_bulk",
      "id": "clearance_confirm_bulk",
      "data-sign": "clearance_confirm_bulk",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": _vm.handleConfirmBulk
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])] : _vm._e()], 2)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "fixed-header": "",
      "useMouseTool": "",
      "data-sign": "clearance_list",
      "columns": _vm.columns,
      "name": "clearanceList",
      "data-source": _vm.data,
      "row-key": "order_no",
      "row-selection": _vm.rowSelection
    },
    scopedSlots: _vm._u([{
      key: "order_no",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "data-sign": "clearance_redirect"
          }
        }, [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.order_no,
            expression: "record.order_no"
          }],
          attrs: {
            "to": {
              name: 'ClearanceDetailPage',
              query: {
                code: record.order_no,
                id: record.id
              },
              params: {
                noCache: 1
              }
            }
          }
        }, [_vm._v(_vm._s(record.order_no))])], 1);
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return [_c('p', [_vm._v(" " + _vm._s(record.warehouse_code) + "[" + _vm._s(record.warehouse_name) + "] ")])];
      }
    }, {
      key: "transit_warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return [_c('p', [_vm._v(" " + _vm._s(record.transit_warehouse_code) + "[" + _vm._s(record.transit_warehouse_name) + "] ")])];
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.create_time ? _c('p', {
          staticClass: "time-container"
        }, [_c('span', {
          staticClass: "time-container-label"
        }, [_vm._v(_vm._s(_vm.t('生成时间')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(record.create_time))])]) : _vm._e(), record.update_time ? _c('p', {
          staticClass: "time-container"
        }, [_c('span', {
          staticClass: "time-container-label"
        }, [_vm._v(_vm._s(_vm.t('更新时间')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(record.update_time))])]) : _vm._e(), record.confirm_time ? _c('p', {
          staticClass: "time-container"
        }, [_c('span', {
          staticClass: "time-container-label"
        }, [_vm._v(_vm._s(_vm.t('确认时间')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(record.confirm_time))])]) : _vm._e()]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {
          staticClass: "operation-btns"
        }, [record.status === _vm.$enum.clearance.ClearanceStatusEnum.UNCONFIRM ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'clearance_confirm_bulk',
            expression: "'clearance_confirm_bulk'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "clearance_confirm",
            "fbu-analyse-name": $t("\u786E\u8BA4")
          },
          on: {
            "click": function ($event) {
              return _vm.handleConfirm(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('确认')))]) : _vm._e()]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "total": _vm.total,
      "isFixed": "",
      "name": "clearanceList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.searchData.page_index,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "page_index", $$v);
      },
      expression: "searchData.page_index"
    }
  })], 1)], 1), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "max-number": 30
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };